import UpdatePassword from "src/components/UpdatePassword/UpdatePassword";
import { IShowUpdatePasswordParams } from "src/models/updatePassword";

export default {
    updatePasswordComponent: null,

    dispose() {
        if (this.updatePasswordComponent) {
            this.updatePasswordComponent.dispose();
        }
        this.updatePasswordComponent = null;
    },

    show(params?: IShowUpdatePasswordParams) {
        if (!this.updatePasswordComponent) {
            this.updatePasswordComponent = new UpdatePassword({
                source: '<x-update-password></x-update-password>'
            });
            this.updatePasswordComponent.attach(document.body);
        }
        this.updatePasswordComponent.show(params)
    }
};